export default __webpack_public_path__ + "static/media/hd2.4d445cdb.webp";